import React from 'react';
import SummaryCosts from "./SummaryCosts";
import Itinerary from "./Itinerary";
import TripDetails from "./TripDetails";
import {Box} from "@mui/material";

const TripSummary = ({showCosts, showItinerary}) => {
    return (
        <>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }} style={{marginTop: 20}}><TripDetails/></Box>
            {showItinerary && <Itinerary/>}
            {showCosts && <SummaryCosts/>}
        </>

    );
};

export default TripSummary;
